<template>
  <v-row style="align-items: center" class="menu px-0 pt-1">
    <v-col cols="12" sm="9">
      <v-text-field
        v-model="search"
        :label="$t('tables.search-label')"
        single-line
        hide-details
        clearable
        class="pa-0 ma-0"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="2">
      <v-checkbox
        v-model="root"
        color="primary"
        :label="$t('groups.root')"
        class="checkbox"
      ></v-checkbox>
    </v-col>
    <v-col cols="12" sm="1" class="reset">
      <v-btn block v-on:click="reset" :loading="loading">
        <v-icon>
          mdi-filter-remove-outline
        </v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import debounce from "../../../assets/js/debounce";
export default {
  name: "SearchGroup",
  data: function() {
    let search = this.$route.query.search || "";
    let root = this.$route.query.root || false;
    return {
      search,
      root,
      loading: false
    };
  },
  methods: {
    queryForSearch() {
      let to = { ...this.$route };
      to.query = {
        ...to.query
      };
      let vm = this;
      function formParam(param) {
        if (vm[param]) {
          to.query[param] = vm[param];
        } else {
          delete to.query[param];
        }
      }
      formParam("search");
      formParam("root");
      this.$router.push(to);
    },
    reset() {
      let to = { ...this.$route };
      this.search = "";
      to.query = {};
      this.$router.push(to);
    },
    startQueryForSearch: debounce(function() {
      this.queryForSearch();
    }, 500)
  },
  watch: {
    search() {
      this.startQueryForSearch();
    },
    root() {
      this.queryForSearch();
    }
  }
};
</script>

<style lang="scss" scoped>
.checkbox {
  margin-top: 0;
  &::v-deep .v-input__control .v-input__slot {
    margin-bottom: 0px;
  }
  &::v-deep .v-messages {
    display: none;
  }
}
</style>
